interface DateFormatOptions {
    year?: '2-digit' | 'numeric';
    month?: '2-digit' | 'numeric' | 'narrow' | 'short' | 'long';
    day?: '2-digit' | 'numeric';
    hour?: '2-digit' | 'numeric';
    minute?: '2-digit' | 'numeric';
    second?: '2-digit' | 'numeric';
}

export function convertMsToSeconds(ms: number): number {
    return ms / 1000;
}

export function formatDate(date: Date, lang: string, options?: DateFormatOptions) {
    const formatter = new Intl.DateTimeFormat(lang, options);

    return formatter.format(date);
}

export const getDayAndMonthFromDate = (announceDate: string, lang: string) => {
    const date = new Date(announceDate);

    return date
        ? {
              day: date.getDate(),
              month: formatDate(date, lang, { month: 'long' }),
          }
        : {};
};
